import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {TeamListPage} from './team-list/team-list.page';
import {TeamDetailsPage} from './team-details/team-details.page';
import {TeamCallsHistoryPage} from './team-calls-history/team-calls-history.page';
import {TeamCallsHistoryIframePage} from './team-calls-history-iframe/team-calls-history-iframe.page';

const routes: Routes = [
    {
        path: '',
        component: TeamListPage
    },
    {
        path: 'details/:delegateId',
        component: TeamDetailsPage
    },
    {
        path: 'calls/:delegateId',
        component: TeamCallsHistoryIframePage
    },
    // {
    //     path: 'calls/:delegateId',
    //     component: TeamCallsHistoryPage
    // }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class TeamRoutingModule {
}
